var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0H24V2.688H0V0ZM0 9.312V6.68667H24V9.312H0ZM0 16V13.312H24V16H0Z","fill":"black"}));
}

Menu.defaultProps = {"viewBox":"0 0 24 16","fill":"none"};

module.exports = Menu;

Menu.default = Menu;
